// Copyright (c) 2016 Deere & Company

import KeyValuePair, {getDefaultState as getKeyValueDefaultState} from './key-value-pair';
import t from 'tcomb';

const ClaimPart = t.struct({
    coreValues: t.maybe(t.Number),
    dnsListPrice: t.maybe(t.Number),
    dnsNetPrice: t.maybe(t.Number),
    guid: t.String,
    id: t.String,
    invoiceNumber: t.String,
    lineNumber: t.Number,
    onShelfCost: t.maybe(t.Number),
    partAdditive: t.maybe(t.Number),
    partDescription: t.String,
    partNumber: t.String,
    partReturnStatus: KeyValuePair,
    partSerialNumber: t.String,
    partValue: t.maybe(t.Number),
    quantity: t.maybe(t.Number),
    reimbursementAmount: t.maybe(t.Number),
    taxAmount: t.maybe(t.Number),
    unit: KeyValuePair
}, {
    name: 'ClaimPart',
    strict: true
});

export const getDefaultState = () => new ClaimPart({
    dnsListPrice: null,
    dnsNetPrice: null,
    guid: '',
    id: '',
    invoiceNumber: '',
    lineNumber: 0,
    partDescription: '',
    partNumber: '',
    partReturnStatus: getKeyValueDefaultState(),
    partSerialNumber: '',
    quantity: null,
    unit: getKeyValueDefaultState()
});

export default ClaimPart;



// WEBPACK FOOTER //
// ./~/@deere/cps-it.warranty-model-factory/lib/claim-item-part.js